<template>
  <div>
    <wc-page-title title='Unsent invoices'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='8'>
          <wc-data-box
            title='Setup'
            titleIcon='mdi-cogs'
          >
            <v-card-text>
              <v-btn
                small
                depressed
                color='success'
                @click='runReport'
                :loading='isLoading'
              >Run report</v-btn>
            </v-card-text>
          </wc-data-box>
        </v-col>
        <v-col cols='12' md='4'>
          <wc-data-box
            title='Totals'
          >
            <v-card-text>
              <table width='100%'>
                <tr>
                  <td class='title'>Count</td>
                  <td class='title text-right'>{{ invs.length }}</td>
                </tr>
                <tr>
                  <td colspan='2'><v-divider class='my-3'></v-divider></td>
                </tr>
                <tr>
                  <td class='title'>Total</td>
                  <td class='title text-right'>{{ reportTotal | decMoney }}</td>
                </tr>
              </table>
            </v-card-text>
          </wc-data-box>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='Report Results'
            titleIcon='mdi-finance'
            showSearch
            v-model='search'
          >
            <v-data-table
              :items='invs'
              :headers='headers'
              :loading='isLoading'
              :search='search'
              dense
              :items-per-page='-1'
              disable-pagination
              hide-default-footer
              @click:row='openInvoice'
            >
              <template v-slot:item.number='{ item }'>
                {{ item.number }}
                <v-icon small v-if="item.status === 'on_hold'" color='error'>{{$icons.hold.icon}}</v-icon>
              </template>
                <template v-slot:item.original_amount='{ item }'>
                  {{ item.original_amount | dec }}
                </template>
                <template v-slot>
                  <status-chip :status='item.status_label'></status-chip>
                </template>
                <template v-slot:item.amount_os='{ item }'>
                  {{ item.amount_os | dec }}
                </template>
              </v-data-table>
            </wc-data-box>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script>
import accountingAPI from '@/api/accounting';
import StatusChip from '@/modules/accounting/components/invoice/StatusChip';
import miscServices from '@/services/misc';
import formRules from '@/mixins/formRules';
import _ from 'lodash';

export default {
  name: 'unpaid-invoices',
  mixins: [formRules],
  data: () => ({
    isLoading: false,
    invs: [],
    search: '',
    headers: [
      { text: 'Number', value: 'number' },
      { text: 'Date Created', value: 'invoice_date'},
      { text: 'Bill to', value: 'bill_to_display' },
      { text: 'Original Amount', value: 'original_amount', align: 'right' },
      { text: 'Status', value: 'status_label', align: 'center' },
      { text: 'Amount OS', value: 'amount_os', align: 'right' }
    ]
  }),
  computed: {
    reportTotal () {
      return _.sumBy(this.invs, 'original_amount')
    }
  },
  methods: {
    async runReport () {
      this.isLoading = true
      this.search = ''
      this.invs = await accountingAPI.getUnsentInvoices();
      console.log(JSON.parse(JSON.stringify(this.invs)))
      this.isLoading = false
    },
    openInvoice (inv) {
      miscServices.openInNewTab({ name: 'InvoiceOverview', params: { id: inv.id } })
    }
  },
  components: {
    'status-chip': StatusChip
  }
}
</script>
